module.exports = __webpack_public_path__ + "static/networks6-2f02e375e348b42adc3dace437bc867b.jpg";